import { APP_CUSTOM_ERROR } from "../../constants/AppVarConstants";
import {
  COMPANY_USER_LIST,
  CREATE_COMPANY_USER,
  DELETE_COMPANY_USER,
  UPDATE_COMPANY_USER,
  UPDATE_USER_STATUS,
  USER_COMPANY_LISTING,
} from "../api/config";
import API_MIDDLEWARE from "../api/middleware";
import {
  SET_COMPANY_USER_LIST,
  SET_USER_LIST,
  SET_USER_LIST_PAGE,
  SET_USER_LIST_ROWS_PER_PAGE,
} from "./actionTypes";
import { beginAjaxCall, endAjaxCall } from "./ajaxStatusActions";
import { setErrorMessage, setSuccessMessage } from "./appActions";

export const getUserList = ({searchText, cid}: {searchText: string, cid: number}): any => {
  return (dispatch: any, getState: any) => {
    const state = getState();
    const payload = {
        searchQuery: searchText || "",
        page: state.userList.page,
        fetchSize: state.userList.rowsPerPage,
    };
    dispatch(beginAjaxCall());
    API_MIDDLEWARE(USER_COMPANY_LISTING(cid), "POST", { "Content-Type": "application/json" }, payload)
      .then((res) => {
        dispatch({ type: SET_USER_LIST, payload: res?.result });
        dispatch(endAjaxCall());
      })
      .catch((err) => {
        dispatch(setErrorMessage(err.errorMsg ?? APP_CUSTOM_ERROR));
        dispatch(endAjaxCall());
      });
  };
};

export const getCompanyList = (): any => {
  return async (dispatch: any) => {
    try {
      dispatch(beginAjaxCall());

      const res = await API_MIDDLEWARE(
        COMPANY_USER_LIST,
        "GET",
        { "Content-Type": "application/json" }
      );

      dispatch({ type: SET_COMPANY_USER_LIST, payload: res?.result });
      dispatch(endAjaxCall());

      return res?.result;
    } catch (err: any) {
      dispatch(setErrorMessage(err?.errorMsg ?? APP_CUSTOM_ERROR));
      dispatch(endAjaxCall());
      return [];
    }
  };
};

export const updatePerPage = (value: any): any => {
  return (dispatch: any) => {
    dispatch({ type: SET_USER_LIST_ROWS_PER_PAGE, payload: value });
  };
};

export const updatePage = (value: any): any => {
  return (dispatch: any) => {
    dispatch({ type: SET_USER_LIST_PAGE, payload: value });
  };
};

export const createUser = (payload: any): any => {
  return async (dispatch: any) => {
    try {
      dispatch(beginAjaxCall());

      const res = await API_MIDDLEWARE(
        CREATE_COMPANY_USER(payload?.cid),
        "POST",
        { "Content-Type": "application/json" },
        payload
      );
      dispatch(endAjaxCall());
      dispatch(setSuccessMessage("User created successfully!"));
      return res?.result;
    } catch (err: any) {
      dispatch(setErrorMessage(err?.errorMsg ?? APP_CUSTOM_ERROR));
      dispatch(endAjaxCall());
      return null;
    }
  };
};

export const updateUser = (payload: any): any => {
  return async (dispatch: any) => {
    try {
      dispatch(beginAjaxCall());

      const res = await API_MIDDLEWARE(
        UPDATE_COMPANY_USER(payload.id, payload?.cid),
        "POST",
        { "Content-Type": "application/json" },
        payload
      );
      dispatch(endAjaxCall());
      dispatch(setSuccessMessage("User updated successfully!"));
      return res?.result;
    } catch (err: any) {
      dispatch(setErrorMessage(err?.errorMsg ?? APP_CUSTOM_ERROR));
      dispatch(endAjaxCall());
      return null;
    }
  };
};

export const deleteUser = (userId: any, cid: number): any => {
  return async (dispatch: any) => {
    try {
      dispatch(beginAjaxCall());

      const res = await API_MIDDLEWARE(
        DELETE_COMPANY_USER(userId, cid),
        "DELETE",
        { "Content-Type": "application/json" }
      );
      dispatch(endAjaxCall());
      dispatch(setSuccessMessage("User deleted successfully!"));
      return res?.result;
    } catch (err: any) {
      dispatch(setErrorMessage(err?.errorMsg ?? APP_CUSTOM_ERROR));
      dispatch(endAjaxCall());
      return null;
    }
  };
};

export const updateUserStatus = (userId: number, companyId: number, status: string): any => {
  return async (dispatch: any) => {
    try {
      dispatch(beginAjaxCall());
      const res = await API_MIDDLEWARE(
        UPDATE_USER_STATUS(userId, companyId, status),
        "PUT",
        { "Content-Type": "application/json" },
        {} // Empty body since status is passed as query parameter
      );
      dispatch(endAjaxCall());
      dispatch(setSuccessMessage(`User ${status.toLowerCase()} successfully!`));
      return res?.result;
    } catch (err: any) {
      dispatch(setErrorMessage(err?.errorMsg ?? APP_CUSTOM_ERROR));
      dispatch(endAjaxCall());
      return false;
    }
  };
};